import useStyles from './useStyles'
import { IconButton, Tooltip } from '@mui/material'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { namesTypesTraduc } from '../../../../../utils/traducTypes'

function TableItem ({ item, setLoading, userInstance }) {
  const classes = useStyles()

  const getIconStatus = (code) => {
    switch (code) {
      case 'ACTIVE':
        return (
          <Tooltip title="Activo">
            <IconButton>
              <GppGoodOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'GRANTED':
        return (
          <Tooltip title="Acceso habilitado">
            <IconButton>
              <GppGoodOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'REVOKED':
        return (
          <Tooltip title={'Acceso revocado'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      case 'DELETED':
        return (
          <Tooltip title={'Eliminado'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      case 'WAITING_VALIDATION':
        return (
          <Tooltip title={'Esperando validación'}>
            <IconButton>
              <HelpOutlineOutlinedIcon className={classes.hoverButtonDisable} />
            </IconButton>
          </Tooltip>
        )
      case 'BLOCKED':
        return (
          <Tooltip title={'Bloqueado'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      case 'INACTIVE':
        return (
          <Tooltip title={'Inactivo'}>
            <IconButton>
              <HelpOutlineOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
      case 'SUSPENDED':
        return (
          <Tooltip title={'Suspendido'}>
            <IconButton>
              <GppMaybeIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )

      default:
        return (
          <Tooltip title={code}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
    }
  }

  function traducName (code) {
    let name = null

    namesTypesTraduc.map((typeTraduc) => {
      if (typeTraduc.code === code) {
        name = typeTraduc.name
      }
      return name
    })

    return name
  }
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemIcon}>
          {getIconStatus(
            userInstance?.userAppAccessStatusCode ||
              item?.status?.userStatusCode
          )}
        </td>
        <td className={classes.itemEmail}>{item?.account?.email}</td>
        <td className={classes.itemName}>
          {item.account?.firstName || '- -'} {item.account?.lastName || '- -'}
        </td>
        <td className={classes.itemTypeUser}>
          {traducName(item.type?.organizationUserTypeCode) || '- -'}
        </td>
        {/* <td className={classes.itemDate}>
          {' '}
          {formatDate(item.startDate)
            ? formatDate(item.startDate)
            : 'Fecha no definida'}{' '}
          /{' '}
          {formatDate(item.finishDate)
            ? formatDate(item.finishDate)
            : 'Fecha no definida'}
        </td>

        <td className={classes.itemTypeComercial}>
          {item.user?.commercialType?.organizationCommercialUserTypeCode ||
            '- -'}
        </td> */}
        <td className={classes.itemKebab}>
          {/* <ModalMenuItem item={item} userRol={role} setLoading={setLoading} /> */}
        </td>
      </tr>
    </>
  )
}

export default TableItem
